import { Dialog } from '@/shared/ui'
import styled from 'styled-components'

export const Content = styled(Dialog.Content)`
	max-width: unset;
	width: unset;
`

export const ButtonsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	margin-top: 1rem;
	margin-bottom: 1rem;
	align-items: center;
	justify-content: flex-end;
	gap: 0.5rem;

	& > button {
		width: 100%;
	}
`
